import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import FintracPagePending from './FintracPagePending'
import FintracPageSubmittedReports from './FintracPageSubmittedReports'
import Card from '@mui/material/Card'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{p: 3}}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const FintracReportTable = () => {
  const [value, setValue] = React.useState(0)
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <div>
      <h2>Fintrac Report</h2>
      <Card sx={{minWidth: 275}}>
        <Box sx={{width: '100%'}}>
          <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
            <Tabs value={value} onChange={handleChange} aria-label='basic tabs example'>
              <Tab label='Pending' {...a11yProps(0)} />
              <Tab label='Submitted' {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <FintracPagePending />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <FintracPageSubmittedReports />
          </CustomTabPanel>
        </Box>
      </Card>
    </div>
  )
}

export default FintracReportTable
